<template>
  <Teleport to="body">
    <div
      v-if="modelValue"
      class="we-modal z-50 flex md:px-10"
      :class="modalClasses"
    >
      <div
        class="we-modal__wrapper h-auto bg-white shadow-sm relative"
        :class="[modalSize, wrapperClasses, isBusiness ? 'font-nunito-sans' : 'font-nunito']"
      >
        <div>
          <div v-if="!noCloseButton" class="absolute right-5 top-5 cursor-pointer">
            <we-icon name="close" class="fill-primary-brand-200" @click="hideModal" />
          </div>
          <slot name="header" />
        </div>
        <div>
          <slot name="content" />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useScreen } from '@/composables'
import WeIcon from './WeIcon'

const emit = defineEmits(['update:modelValue', 'close'])

const props = defineProps({
  modelValue: {
    type: Boolean
  },

  modalSize: {
    type: String,
    default: 'max-w-[100vw] md:w-[90vw]'
  },

  noCloseButton: {
    type: Boolean
  },

  noBackdrop: {
    type: Boolean,
    default: false
  },

  bottomSheet: {
    type: Boolean,
    default: false
  }
})

const store = useStore()
const isBusiness = computed(() => store.getters.getTarget === 'business')

const { isSmall } = useScreen()

const hideModal = () => {
  emit('update:modelValue', false)
  emit('close')
}

const modalClasses = computed(() => {
  if (isSmall.value && props.bottomSheet) {
    return [
      'bottom-0 fixed w-full justify-center items-end',
      !props.noBackdrop && 'bg-black bg-opacity-50 h-[100vh]'
    ]
  }
  if (isSmall.value) {
    return [
      'bottom-0 fixed h-[100vh] w-full overflow-hidden justify-center items-center',
      !props.noBackdrop && 'bg-black bg-opacity-50'
    ]
  }
  return [
    'fixed inset-0 w-full h-full justify-center items-center overflow-y-auto',
  ]
})

const wrapperClasses = computed(() => {
  if (isSmall.value && props.bottomSheet) {
    return 'rounded-t-3xl pt-8 pb-8 w-full'
  }
  return 'rounded-3xl pt-14 pb-8 md:pt-10'
})

</script>

<style lang="scss" scoped>
.we-modal {
  @media (min-width: 769px) {
    background-color: rgba(0, 0, 0, 0.3);
  }
}
</style>
